<script lang="ts">
  import { browser } from '$app/environment';
  import type { HeroBannerCarousel } from '$lib/types/contentTypes';
  import Carousel from 'svelte-carousel';
  import ArrowButton from '../control/ArrowButton.svelte';
  import HeroBanner from './HeroBanner.svelte';
  let heroHeight = 'min-h-[250px]';
  let heroMargin = 'my-6';

  export let heroBannersCollection: HeroBannerCarousel['heroBanners'];

  let carousel: any;
  const itemCount: number = heroBannersCollection?.items?.length || 0;

  const handleNextClick = () => {
    carousel.goToNext();
  };
  const handlePrevClick = () => {
    carousel.goToPrev();
  };
</script>

<section class="w-full relative mx-auto">
  {#if browser && itemCount}
    <Carousel
      bind:this={carousel}
      arrows={false}
      dots={false}
      infinite={true}
      particlesToShow={1}
      autoplay={true}
      autoplayDuration={3500}
      pauseOnFocus={true}
    >
      {#if heroBannersCollection?.items?.length && itemCount > 1}
        {#each heroBannersCollection?.items as heroBanner}
          <HeroBanner {heroBanner} {heroHeight} {heroMargin} />
        {/each}
      {/if}
    </Carousel>
  {/if}
  {#if itemCount > 1}
    <div class="justify-center items-start gap-8 flex my-7 sm:my-12 flex-row w-full">
      <ArrowButton direction="left" on:click={handlePrevClick} />
      <ArrowButton direction="right" on:click={handleNextClick} />
    </div>
  {:else if heroBannersCollection?.items?.length}
    {#each heroBannersCollection.items as heroBanner}
      <HeroBanner {heroBanner} {heroHeight} {heroMargin} />
    {/each}
    <div class="my-7 sm:my-12 flex-row w-full"></div>
  {/if}
</section>
